/* eslint-disable no-lonely-if */
import { Checkbox, FormControlLabel, Grid, Typography, makeStyles } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, searchArray } from '../utils/Utils';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { PxFilters } from '../common/PxFilters';
import ZeroState from '../common/ZeroState';
import CarIcon from '../../assets/CarIcon';

const useStyle = makeStyles({
  middleItem: {
    height: '65vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  certInfo: {
    width: '98%',
    height: '50px',
    display: 'flex',
    gap: '60px',
    padding: '15px 0px',
    borderBottom: '1px solid #D0D5DD',
  },
  heading: {
    color: '#667085',
  },
  item: {
    color: '#10182B',
    marginTop: '5px',
  },
  selectAllCheckbox: {
    borderRadius: '8px',
    borderColor: '#D0D5DD',
  },
  gridContainerStyle: {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    overflowY: 'auto',
  },
  container: {
    width: '98%',
    borderRadius: '6px',
    background: '#fff',
    marginTop: '15px',
  },
  filter: {
    padding: '0px',
    marginTop: '5px',
  },
  depContainer: {
    width: '98%',
    borderRadius: '6px',
    background: '#fff',
  },
  dep: {
    borderLeft: '2px solid #D9D6FE',
    padding: '10px',
  },
  search: {
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
  },
  listContainer: {
    height: '30vh',
    borderLeft: '2px solid #D9D6FE',
  },
  selectAll: {
    background: 'lightGrey',
    width: '100%',
    marginLeft: '0px',
  },
  filedName: {
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  centerBoxElement: {
    borderLeft: '2px solid #D9D6FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30vh',
  },
  countBox: {
    padding: '5px',
    borderRadius: '10px',
    backgroundColor: '#D9D6FE',
    fontSize: '10px !important',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export function AssignFlow({
  assignPayload,
  setAssignPayload,
  endDate,
  filters,
  appliedFilters,
  setAppliedFilters,
  DEFAULT_FILTERS,
}) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const selectedCertInfo = useSelector((state) => state.certificateData.selectedCertInfo);

  const [assignDealerList, setAssignDealerList] = useState([]);
  const [searchDealershipValue, setSearchDealershipValue] = useState('');
  const [filteredDealerships, setFilteredDealerships] = useState([]);
  const [searchUserValue, setSearchUser] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [childrenViewList, setChildrenViewList] = useState({
    dealer: {},
    dep: {},
    role: {},
  });

  useEffect(() => {
    setFilteredDealerships(assignDealerList);
  }, [assignDealerList]);

  useEffect(() => {
    const temp = childrenViewList.role?.employees || [];
    setFilteredUsers(temp);
  }, [childrenViewList]);

  const handleDealershipSearch = (e) => {
    const input = e.target.value;
    setSearchDealershipValue(input);

    // Filter the dealerships based on the search input
    const filtered = searchArray(assignDealerList || [], ['name'], input);
    setFilteredDealerships(filtered);
  };

  const handleUserSearch = (e) => {
    const input = e.target.value;
    setSearchUser(input);

    // Filter the dealerships based on the search input
    const filtered = searchArray(childrenViewList.role?.employees || [], ['name'], input);
    setFilteredUsers(filtered);
  };

  const getDealershipList = async () => {
    dispatch(showProgress(true));

    const sales = appliedFilters.salesPipelineStatus?.map((i) => i.id) || [];
    const groupIds = appliedFilters.dealerGroup?.map((i) => i.id) || [];
    const PxHash = appliedFilters.pxOwners?.map((i) => i.hash) || [];
    const planIds = appliedFilters.plans?.map((i) => i.id) || [];

    const payload = {
      certificationId: selectedCertInfo.id,
      endDate: moment(endDate).format('YYYY-MM-DD'),
      filters: {
        source: appliedFilters.source,
        dealerGroupIds: groupIds,
        salesPipelineStatus: sales,
        pxOwnerHash: PxHash,
        plans: planIds,
      },
    };

    try {
      const res = await service.post(apiEndpoints.CERT_ASSIGN_DEALER_LIST, payload);
      setAssignDealerList(res || []);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    getDealershipList();
  }, []);

  const updateUserInPayload = (dealerId, departmentId, roleId, userId) => {
    setAssignPayload((prevPayload) => {
      const updatedPayload = { ...prevPayload };

      if (!updatedPayload[dealerId]) {
        updatedPayload[dealerId] = {};
      }
      if (!updatedPayload[dealerId][departmentId]) {
        updatedPayload[dealerId][departmentId] = {};
      }

      if (
        updatedPayload[dealerId][departmentId][roleId] &&
        updatedPayload[dealerId][departmentId][roleId].length === 0
      ) {
        const temp = childrenViewList.role.employees?.filter((emp) => !emp.disabled && emp.hash !== userId) || [];
        const remainingUsers = temp?.map((emp) => emp.hash) || [];
        if (remainingUsers.length === 0) {
          delete updatedPayload[dealerId][departmentId][roleId];
          if (_isEmpty(updatedPayload[dealerId][departmentId])) {
            delete updatedPayload[dealerId][departmentId];

            if (_isEmpty(updatedPayload[dealerId])) {
              delete updatedPayload[dealerId];
            }
          }
        } else {
          updatedPayload[dealerId][departmentId][roleId] = remainingUsers;
        }
      } else {
        if (!updatedPayload[dealerId][departmentId][roleId]) {
          updatedPayload[dealerId][departmentId][roleId] = [];
        }
        const userIndex = updatedPayload[dealerId][departmentId][roleId].indexOf(userId);
        if (userIndex !== -1) {
          updatedPayload[dealerId][departmentId][roleId].splice(userIndex, 1);

          // if list becomes [] (all user unselected), then remove role id
          if (updatedPayload[dealerId][departmentId][roleId]?.length === 0) {
            delete updatedPayload[dealerId][departmentId][roleId];

            // if no role ids in department, then remove dep id
            if (Object.keys(updatedPayload[dealerId][departmentId]).length === 0) {
              delete updatedPayload[dealerId][departmentId];

              // if no dep ids in dealer, then remove dealer id
              if (Object.keys(updatedPayload[dealerId]).length === 0) {
                delete updatedPayload[dealerId];
              }
            }
          }
        } else {
          updatedPayload[dealerId][departmentId][roleId].push(userId);
          if (updatedPayload[dealerId][departmentId][roleId]?.length === childrenViewList.role?.employees?.length) {
            updatedPayload[dealerId][departmentId][roleId] = [];
          }
        }
      }

      return updatedPayload;
    });
  };

  const handleUserSelect = (userId) => {
    const dealerId = childrenViewList.dealer.id;
    const departmentId = childrenViewList.dep.id;
    const roleId = childrenViewList.role.id;

    updateUserInPayload(dealerId, departmentId, roleId, userId);
  };

  const getColor = (isChecked, isIndeterminate, disabled) => {
    if (disabled) return '#D0D5DD';
    return isChecked || isIndeterminate ? '#5925DC' : '#10182B';
  };

  const handleDealerChildrenView = (id) => {
    const selectedItem = filteredDealerships.filter((dealer) => dealer.id === id)[0];

    setChildrenViewList({
      dealer: selectedItem,
      dep: {},
      role: {},
    });
  };

  const handleDepChildrenView = (id) => {
    const selectedItem = childrenViewList.dealer?.departments?.filter((dep) => dep.id === id)[0];
    const temp = childrenViewList;

    setChildrenViewList({
      dealer: temp.dealer,
      dep: selectedItem,
      role: {},
    });
  };

  const handleRoleChildrenView = (id) => {
    const selectedItem = childrenViewList.dep?.roles?.filter((role) => role.id === id)[0];
    const temp = childrenViewList;

    setChildrenViewList({
      dealer: temp.dealer,
      dep: childrenViewList.dep,
      role: selectedItem,
    });
  };

  const handleSelectRole = (event, role) => {
    const allPossibleUsers = role.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
    const dealerId = childrenViewList.dealer.id;
    const depId = childrenViewList.dep.id;
    const emps = role.employees?.filter((emp) => !emp.disabled)?.map((em) => em.hash) || [];
    const empHash = role.employees?.length === emps?.length ? [] : emps;
    const temp = { ...assignPayload };

    const isCheck =
      temp[dealerId] &&
      temp[dealerId][depId] &&
      temp[dealerId][depId][role.id] &&
      (allPossibleUsers.length === temp[dealerId][depId][role.id].length ||
        temp[dealerId][depId][role.id].length === 0);

    if (!isCheck) {
      if (!temp[dealerId]) {
        temp[dealerId] = {};
      }
      if (!temp[dealerId][depId]) {
        temp[dealerId][depId] = {};
      }
      temp[dealerId][depId][role.id] = empHash;
    } else {
      delete temp[dealerId][depId][role.id];
      if (Object.keys(temp[dealerId][depId]).length === 0) {
        delete temp[dealerId][depId];
        if (Object.keys(temp[dealerId]).length === 0) {
          delete temp[dealerId];
        }
      }
    }

    setAssignPayload(temp);
  };

  const handleSelectDep = (event, dep) => {
    const isCheck = event.target.checked;
    const dealerId = childrenViewList.dealer.id;
    const temp = { ...assignPayload };
    const roles = {};

    dep.roles.forEach((role) => {
      const emps = role.employees?.filter((emp) => !emp.disabled)?.map((em) => em.hash) || [];
      const empHash = role.employees?.length === emps?.length ? [] : emps;
      roles[role.id] = empHash;
    });

    if (isCheck) {
      if (!temp[dealerId]) {
        temp[dealerId] = {};
      }
      temp[dealerId][dep.id] = roles;
    } else {
      delete temp[dealerId][dep.id];
      if (Object.keys(temp[dealerId]).length === 0) {
        delete temp[dealerId];
      }
    }

    setAssignPayload(temp);
  };

  const handleSelectDealer = (event, dealer) => {
    const temp = { ...assignPayload };
    const totalDeps = dealer.departments?.filter((d) => !d.disabled)?.length || 0;
    const selectedDeps = (temp[dealer.id] && Object.keys(temp[dealer.id])?.length) || 0;

    const isCheck = totalDeps === selectedDeps;

    const deps = {};

    dealer.departments?.forEach((dep) => {
      if (!dep.disabled) {
        const roles = {};
        dep.roles?.forEach((role) => {
          const emps = role.employees?.filter((emp) => !emp.disabled)?.map((em) => em.hash) || [];
          const empHash = role.employees?.length === emps?.length ? [] : emps;
          roles[role.id] = empHash;
        });
        deps[dep.id] = roles;
      }
    });

    if (!isCheck) {
      temp[dealer.id] = deps;
    } else {
      delete temp[dealer.id];
    }
    setAssignPayload(temp);
  };

  const isAllUserSelected = () => {
    const { dealer, dep, role } = childrenViewList;
    const temp = { ...assignPayload };
    const allPossibleUsers = role.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];

    if (!temp[dealer.id]) return false;
    if (!temp[dealer.id][dep.id]) return false;
    if (!temp[dealer.id][dep.id][role.id]) return false;
    if (
      temp[dealer.id][dep.id][role.id].length !== 0 &&
      temp[dealer.id][dep.id][role.id].length !== allPossibleUsers.length
    )
      return false;

    return true;
  };

  const handleSelectAllUser = () => {
    const { dealer, dep, role } = childrenViewList;
    const temp = { ...assignPayload };
    if (isAllUserSelected()) {
      delete temp[dealer.id][dep.id][role.id];

      // if no role ids in department, then remove dep id
      if (Object.keys(temp[dealer.id][dep.id]).length === 0) {
        delete temp[dealer.id][dep.id];

        // if no dep ids in dealer, then remove dealer id
        if (Object.keys(temp[dealer.id]).length === 0) {
          delete temp[dealer.id];
        }
      }
    } else {
      if (!temp[dealer.id]) {
        temp[dealer.id] = {};
      }
      if (!temp[dealer.id][dep.id]) {
        temp[dealer.id][dep.id] = {};
      }
      const allPossibleUsers = role.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
      const toSelect = role.employees?.length === allPossibleUsers.length ? [] : allPossibleUsers;
      temp[dealer.id][dep.id][role.id] = toSelect;
    }
    setAssignPayload(temp);
  };

  function isAllRoleSelected() {
    const { dealer, dep } = childrenViewList;
    const temp = { ...assignPayload };
    if (!temp[dealer.id]) return false;
    if (!temp[dealer.id][dep.id]) return false;

    let flag = true;

    dep.roles?.forEach((r) => {
      if (!temp[dealer.id][dep.id][r.id] && !r.disabled) flag = false;

      const allPossibleUsers = r.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
      if (
        !r.disabled &&
        !(
          temp[dealer.id][dep.id][r.id]?.length === 0 ||
          temp[dealer.id][dep.id][r.id]?.length === allPossibleUsers.length
        )
      ) {
        flag = false;
      }
    });

    return flag;
  }

  const handleSelectAllRole = () => {
    const { dealer, dep } = childrenViewList;
    const temp = { ...assignPayload };

    if (isAllRoleSelected()) {
      delete temp[dealer.id][dep.id];
      if (Object.keys(temp[dealer.id]).length === 0) {
        delete temp[dealer.id];
      }
    } else {
      if (!temp[dealer.id]) {
        temp[dealer.id] = {};
      }
      if (!temp[dealer.id][dep.id]) {
        temp[dealer.id][dep.id] = {};
      }
      dep.roles?.forEach((role) => {
        if (!role.disabled) {
          const allPossibleUsers = role.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
          const toSelect = role.employees?.length === allPossibleUsers.length ? [] : allPossibleUsers;
          temp[dealer.id][dep.id][role.id] = toSelect;
        }
      });
    }

    setAssignPayload(temp);
  };

  const isAllDepSelected = () => {
    const { dealer } = childrenViewList;
    const temp = { ...assignPayload };
    if (!temp[dealer.id]) return false;

    let flag = true;

    dealer.departments?.forEach((dep) => {
      if (!temp[dealer.id][dep.id] && !dep.disabled) {
        flag = false;
      }

      if (!dep.disabled && temp[dealer.id][dep.id]) {
        dep.roles?.forEach((r) => {
          if (!temp[dealer.id][dep.id][r.id] && !r.disabled) flag = false;

          const allPossibleUsers = r.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
          if (
            !r.disabled &&
            !(
              temp[dealer.id][dep.id][r.id]?.length === 0 ||
              temp[dealer.id][dep.id][r.id]?.length === allPossibleUsers.length
            )
          ) {
            flag = false;
          }
        });
      }
    });

    return flag;
  };

  const handleSelectAllDep = () => {
    const { dealer } = childrenViewList;
    const temp = { ...assignPayload };

    if (isAllDepSelected()) {
      delete temp[dealer.id];
    } else {
      if (!temp[dealer.id]) {
        temp[dealer.id] = {};
      }
      dealer.departments?.forEach((dep) => {
        if (!dep.disabled) {
          if (!temp[dealer.id][dep.id]) {
            temp[dealer.id][dep.id] = {};
          }
          dep.roles?.forEach((role) => {
            if (!role.disabled) {
              const allPossibleUsers = role.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
              const toSelect = role.employees?.length === allPossibleUsers.length ? [] : allPossibleUsers;
              temp[dealer.id][dep.id][role.id] = toSelect;
            }
          });
        }
      });
    }
    setAssignPayload(temp);
  };

  const isAllDealerSelected = () => {
    const temp = { ...assignPayload };
    if (_isEmpty(temp)) return false;

    let flag = true;

    filteredDealerships?.forEach((dealer) => {
      if (!temp[dealer.id] && !dealer.disabled) flag = false;

      if (temp[dealer.id] && !dealer.disabled) {
        dealer.departments?.forEach((dep) => {
          if (!temp[dealer.id][dep.id] && !dep.disabled) flag = false;

          if (!dep.disabled && temp[dealer.id][dep.id]) {
            dep.roles?.forEach((r) => {
              if (!temp[dealer.id][dep.id][r.id] && !r.disabled) flag = false;

              const allPossibleUsers = r.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
              if (
                !r.disabled &&
                !(
                  temp[dealer.id][dep.id][r.id]?.length === 0 ||
                  temp[dealer.id][dep.id][r.id]?.length === allPossibleUsers.length
                )
              ) {
                flag = false;
              }
            });
          }
        });
      }
    });

    return flag;
  };

  const handleSelectAllDealer = () => {
    let temp = { ...assignPayload };
    if (isAllDealerSelected()) {
      temp = {};
    } else {
      filteredDealerships?.forEach((dealer) => {
        if (!temp[dealer.id]) {
          temp[dealer.id] = {};
        }
        dealer.departments?.forEach((dep) => {
          if (!dep.disabled) {
            if (!temp[dealer.id][dep.id]) {
              temp[dealer.id][dep.id] = {};
            }
            dep.roles?.forEach((role) => {
              if (!role.disabled) {
                const allPossibleUsers = role.employees?.filter((emp) => !emp.disabled)?.map((emp) => emp.hash) || [];
                const toSelect = role.employees?.length === allPossibleUsers.length ? [] : allPossibleUsers;
                temp[dealer.id][dep.id][role.id] = toSelect;
              }
            });
          }
        });
        if (_isEmpty(temp[dealer.id])) delete temp[dealer.id];
      });
    }
    setAssignPayload(temp);
  };

  const handleUserCheck = (hash) => {
    const selectedDealer = assignPayload[childrenViewList.dealer?.id];
    const selectedDep = selectedDealer && selectedDealer[childrenViewList.dep?.id];
    const selectedRole = selectedDep && selectedDep[childrenViewList.role?.id];

    const isChecked = selectedRole && (selectedRole.includes(hash) || selectedRole.length === 0);

    return !!isChecked;
  };

  const selectDealerships = (
    <Grid container direction="row">
      <Grid item xs={12}>
        {filteredDealerships?.map((dealer) => {
          const totalCheckedDeps = assignPayload[dealer.id] ? Object.keys(assignPayload[dealer.id])?.length || 0 : 0;
          const totalDeps = dealer.departments?.length;
          const isChecked = totalCheckedDeps === totalDeps;
          const isIndeterminate = totalCheckedDeps > 0 && totalCheckedDeps < totalDeps;

          return (
            <Grid
              container
              key={dealer.id}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: childrenViewList.dealer?.id === dealer.id ? '#F4F3FF' : 'white',
                borderRadius: '4px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    color: isChecked || isIndeterminate ? '#5925DC' : '#D0D5DD',
                    borderRadius: '8px',
                  }}
                  checked={isChecked}
                  disabled={dealer.disabled}
                  indeterminate={isIndeterminate}
                  onChange={(e) => {
                    if (dealer.disabled) {
                      ErrorToast(dealer.error);
                    } else {
                      handleDealerChildrenView(dealer.id);
                      handleSelectDealer(e, dealer);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <Grid
                  className={classes.filedName}
                  style={{
                    color: getColor(isChecked, isIndeterminate, dealer.disabled),
                  }}
                  onClick={() => {
                    if (dealer.disabled) {
                      ErrorToast(dealer.error);
                    } else {
                      handleDealerChildrenView(dealer.id);
                    }
                  }}
                >
                  <div>{dealer.name} </div>
                  {totalCheckedDeps && !dealer.disabled ? (
                    <div className={classes.countBox}>
                      {totalCheckedDeps} / {dealer?.departments?.length}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <ChevronRight
                  style={{ cursor: 'pointer', color: getColor(isChecked, isIndeterminate, dealer.disabled) }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
  const selectDeps = (
    <Grid container direction="row">
      <Grid item xs={12}>
        {childrenViewList.dealer?.departments?.map((dep) => {
          const selectedDealer = assignPayload[childrenViewList.dealer?.id];
          const totalCheckedDeps =
            selectedDealer && selectedDealer[dep.id] ? Object.keys(selectedDealer[dep.id])?.length || 0 : 0;
          const totalDeps = dep.roles?.length;
          const isChecked = totalCheckedDeps === totalDeps;
          const isIndeterminate = totalCheckedDeps > 0 && totalCheckedDeps < totalDeps;
          return (
            <Grid
              container
              key={dep.id}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: childrenViewList.dep?.id === dep.id ? '#F4F3FF' : 'white',
                borderRadius: '4px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    color: isChecked || isIndeterminate ? '#5925DC' : '#D0D5DD',
                    borderRadius: '8px',
                  }}
                  checked={isChecked}
                  disabled={dep.disabled}
                  indeterminate={isIndeterminate}
                  onChange={(e) => {
                    if (dep.disabled) {
                      ErrorToast(dep.error);
                    } else {
                      handleDepChildrenView(dep.id);
                      handleSelectDep(e, dep);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography
                  className={classes.filedName}
                  style={{
                    color: getColor(isChecked, isIndeterminate, dep.disabled),
                  }}
                  onClick={() => {
                    if (dep.disabled) {
                      ErrorToast(dep.error);
                    } else {
                      handleDepChildrenView(dep.id);
                    }
                  }}
                >
                  <dep>{dep.name} </dep>
                  {totalCheckedDeps > 0 ? (
                    <dep className={classes.countBox}>
                      {totalCheckedDeps} / {dep?.roles?.length}
                    </dep>
                  ) : null}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <ChevronRight
                  style={{ cursor: 'pointer', color: getColor(isChecked, isIndeterminate, dep.disabled) }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
  const selectRoles = (
    <Grid container direction="row">
      <Grid item xs={12}>
        {childrenViewList.dep?.roles?.map((role) => {
          const selectedDealer = assignPayload[childrenViewList.dealer?.id];
          const selectedDep = selectedDealer ? selectedDealer[childrenViewList.dep?.id] : {};
          const totalChecked = selectedDep && selectedDep[role.id] ? Object.keys(selectedDep[role.id])?.length || 0 : 0;
          const total = role.employees?.length;
          const isChecked = selectedDep && selectedDep[role.id] && selectedDep[role.id].length === 0 && !role.disabled;
          const isIndeterminate = totalChecked > 0 && totalChecked < total && !role.disabled;

          return (
            <Grid
              container
              key={role.id}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: childrenViewList.role?.id === role.id ? '#F4F3FF' : 'white',
                borderRadius: '4px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    color: !!isChecked || !!isIndeterminate ? '#5925DC' : '#D0D5DD',
                    borderRadius: '8px',
                  }}
                  checked={!!isChecked}
                  disabled={role.disabled}
                  indeterminate={!!isIndeterminate}
                  onChange={(e) => {
                    if (role.disabled) {
                      ErrorToast(role.error);
                    } else {
                      handleRoleChildrenView(role.id);
                      handleSelectRole(e, role);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography
                  className={classes.filedName}
                  style={{
                    color: getColor(isChecked, isIndeterminate, role.disabled),
                  }}
                  onClick={() => {
                    if (role.disabled) {
                      ErrorToast(role.error);
                    } else {
                      handleRoleChildrenView(role.id);
                    }
                  }}
                >
                  <div>{role.name} </div>
                  {(isChecked || isIndeterminate) && !role.disabled ? (
                    <div className={classes.countBox}>
                      {isChecked ? role?.employees?.length : totalChecked} / {role?.employees?.length}
                    </div>
                  ) : null}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <ChevronRight
                  style={{ cursor: 'pointer', color: getColor(isChecked, isIndeterminate, role.disabled) }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );

  const selectUsers = (
    <Grid container direction="row">
      <Grid item xs={12}>
        {filteredUsers?.map((emp) => {
          const isChecked = handleUserCheck(emp.hash);

          return (
            <Grid
              container
              key={emp.hash}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: 'white',
                borderRadius: '4px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    color: isChecked ? '#5925DC' : '#D0D5DD',
                    borderRadius: '8px',
                  }}
                  checked={isChecked}
                  disabled={emp?.disabled}
                  onChange={() => {
                    if (emp.disabled) {
                      ErrorToast(emp.error);
                    } else {
                      handleUserSelect(emp.hash);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography
                  className={classes.filedName}
                  style={{
                    color: getColor(isChecked, false, emp.disabled),
                  }}
                  onClick={() => {
                    if (emp.disabled) {
                      ErrorToast(emp.error);
                    }
                  }}
                >
                  <span>{emp.name} </span>
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );

  return (
    <Grid className={classes.middleItem}>
      <Grid className={classes.certInfo}>
        <Grid className={classes.cert}>
          <Typography className={classes.heading}>Certification:</Typography>
          <Typography className={classes.item}>
            {selectedCertInfo?.name} <span style={{ color: '#667085 ' }}>(Id: {selectedCertInfo?.id})</span>
          </Typography>
        </Grid>
        <Grid className={classes.duration}>
          <Typography className={classes.heading}>Duration:</Typography>
          <Typography className={classes.item}>{selectedCertInfo?.duration} Days </Typography>
        </Grid>
        <Grid className={classes.duration}>
          <Typography className={classes.heading}>Due Date:</Typography>
          <Typography className={classes.item}>{moment(endDate).format('YYYY-MM-DD')}</Typography>
        </Grid>
      </Grid>
      <PxFilters
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        DEFAULT_FILTERS={DEFAULT_FILTERS}
        filters={filters}
        onFilter={getDealershipList}
      />
      <Grid container className={classes.depContainer}>
        <Grid item xs={3} style={{ padding: '10px' }}>
          Dealerships
        </Grid>
        <Grid item xs={3} className={classes.dep}>
          Departments
        </Grid>
        <Grid item xs={3} className={classes.dep}>
          Roles
        </Grid>
        <Grid item xs={3} className={classes.dep}>
          User
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between" className={classes.container}>
        <Grid item xs={3} style={{ padding: '10px' }}>
          <input
            type="text"
            placeholder="Search dealership"
            onChange={handleDealershipSearch}
            value={searchDealershipValue}
            className={classes.search}
          />
        </Grid>
        {childrenViewList.role.id && (
          <Grid item xs={3} style={{ padding: '10px' }}>
            <input
              type="text"
              placeholder="Search user"
              className={classes.search}
              value={searchUserValue}
              onChange={handleUserSearch}
            />
          </Grid>
        )}
      </Grid>
      <Grid container className={classes.container}>
        {filteredDealerships?.length >= 1 ? (
          <Grid item xs={3} style={{ height: '30vh' }}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              className={classes.selectAll}
              checked={isAllDealerSelected()}
              onChange={handleSelectAllDealer}
            />
            <Grid
              className={classes.gridContainerStyle}
              style={{ overflowX: 'hidden', overflowY: 'auto', height: '27vh' }}
            >
              {selectDealerships}
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={3} style={{ height: '30vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ZeroState Icon={CarIcon} text="No dealerships found for the applied filters." cardWidth="80%" />
          </Grid>
        )}

        {childrenViewList.dealer.id ? (
          <Grid item xs={3} className={classes.listContainer}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              className={classes.selectAll}
              checked={isAllDepSelected()}
              onChange={handleSelectAllDep}
            />
            <Grid
              className={classes.gridContainerStyle}
              style={{ overflowX: 'hidden', overflowY: 'auto', height: '27vh' }}
            >
              {selectDeps}
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={3} className={classes.centerBoxElement}>
            Select dealership first
          </Grid>
        )}
        {childrenViewList.dep.id ? (
          <Grid item xs={3} className={classes.listContainer}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              className={classes.selectAll}
              onChange={handleSelectAllRole}
              checked={isAllRoleSelected()}
            />
            <Grid
              className={classes.gridContainerStyle}
              style={{ overflowX: 'hidden', overflowY: 'auto', height: '27vh' }}
            >
              {selectRoles}
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={3} className={classes.centerBoxElement}>
            Select department first
          </Grid>
        )}
        {childrenViewList.role.id ? (
          <Grid item xs={3} className={classes.listContainer}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              className={classes.selectAll}
              onChange={handleSelectAllUser}
              checked={isAllUserSelected()}
            />
            <Grid
              className={classes.gridContainerStyle}
              style={{ overflowX: 'hidden', overflowY: 'auto', height: '27vh' }}
            >
              {selectUsers}
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={3} className={classes.centerBoxElement}>
            Select role first
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
